import React from "react";
import { Link } from "react-router-dom";
import { FaRegBuilding, FaChevronRight } from "react-icons/fa";
import TopManufactorerBadge from "../commons/TopManufactorerBadge";

export default function ManufactorerCard({ item, isLastItem, lastItemRef, isFeature = false }) {
    return (
        <Link
            ref={isLastItem ? lastItemRef : null}
            to={`/manufacturers/${item.uri}`}
            className="h-full"
        >
            <div className={`flex p-3 h-full max-h-[240px] overflow-hidden transition-all duration-200 border bg-white/40 backdrop-blur-sm group rounded-xl hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/30 
            ${isFeature 
                ? 'border-white/60 hover:border-purple-500/30 shadow-md hover:shadow-xl min-h-[120px]' 
                : 'border-white/60'
                }`}>
                <div className="flex-shrink-0 mr-3">
                    <div className="flex items-center justify-center text-purple-500 transition-colors rounded-full w-9 h-9 bg-purple-500/10 group-hover:bg-purple-500/20">
                        <FaRegBuilding className="size-4" />
                    </div>
                </div>
                <div className="flex flex-col flex-1 min-w-0">
                    <div>
                        <div className={`font-medium transition-colors text-15 ${isFeature ? "text-secondary group-hover:text-primary inline-block group-hover:text-transparent group-hover:bg-gradient-title group-hover:bg-clip-text" : "text-secondary group-hover:text-primary"
                            }`}>
                            {item.name.replace("&amp;", "&")}
                        </div>
                        <div className="text-14 text-secondary/80">
                            Pharmaceutical Manufacturer
                        </div>
                        {item.description && <div className="text-14 text-secondary/80">
                            {item.description}
                        </div>}
                    </div>
                    {(isFeature || item.is_sponsor) && (
                        <div className="mt-auto">
                            <TopManufactorerBadge />
                        </div>
                    )}
                </div>

                <div className="self-center ml-2 -mr-1 transition-transform transform group-hover:translate-x-1">
                    <div className="p-1 rounded-full text-secondary/70 group-hover:text-purple-500">
                        <FaChevronRight className="size-3" />
                    </div>
                </div>
            </div>
        </Link>
    );
}
